import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { authGuard } from './auth/guards/auth.guard';
import { permissionGuard } from './auth/guards/permission.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes'),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        component: HomePageComponent,
        pathMatch: 'full',
      },
      {
        path: 'quotes',
        canActivate: [permissionGuard],
        data: { module: 'COTIZACIONES' },
        loadChildren: () => import('./quotes/quotes.routes'),
      },
      {
        path: 'payments',
        loadChildren: () => import('./payments/payments.routes'),
      },
      {
        path: 'statistics',
        loadChildren: () => import('./statistics/statistics.routes'),
      },
      {
        path: 'policies',
        canActivate: [permissionGuard],
        data: { module: 'POLIZAS' },
        loadChildren: () => import('./policies/policies.routes'),
      },
      {
        path: 'claims',
        canActivate: [permissionGuard],
        data: { module: 'RECLAMACIONES' },
        loadChildren: () => import('./claims/claims.routes'),
      },
      {
        path: 'safe-surgery',
        canActivate: [permissionGuard],
        data: { module: 'MANTENIMIENTO' },
        loadChildren: () => import('./safe-surgery/safe-surgery.routes'),
      },
      // {
      //   path: 'users',
      //   canActivate: [permissionGuard],
      //   data: { module: 'MANTENIMIENTO', permission: 'MIS_USUARIOS' },
      //   loadChildren: () => import('./users/users.routes'),
      // },
      {
        path: 'clients',
        canActivate: [permissionGuard],
        data: { module: 'CONSULTA', permission: 'CONSULTA_CLIENTES_GENERAL' },
        loadChildren: () => import('./clients/clients.routes'),
      },
      {
        path: 'insureds',
        canActivate: [permissionGuard],
        data: { module: 'ADMINISTRATIVO', permission: 'CONSULTA_ASEGURADOS_GENERAL' },
        loadChildren: () => import('./insureds/insureds.routes'),
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
];
